import React, { useState } from "react";
import { Link } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link as MuiLink } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Grid from "@mui/material/Grid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";

import logo from "assets/logo.png";
import styles from "./navigation.css.js";

const ITEM_HEIGHT = 48;

const Navigation = (props) => {
  // Declare a new state variable, which we'll call "count"
  const smallScreen = useMediaQuery("(max-width:960px)");
  const hideTitle = useMediaQuery("(max-width:690px)");
  const [value] = useState(props.value);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const classes = styles();

  function handleClick(event) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  return (
    <AppBar position="static" color="default" className={classes.appBar}>
      <Toolbar>
        <Grid
          container
          className={classes.navigationContainer}
          sx={{ alignItems: "center" }}
        >
          <img src={logo} alt="logo" className={classes.logo} />
          {!hideTitle && value === 1 ? (
            <Typography variant="h2" className={classes.title}>
              <span className={classes.skinnyText}>Löydä Oma</span> Taksi
            </Typography>
          ) : null}

          {!smallScreen ? (
            <Tabs value={value} className={classes.navigationLinkContainer}>
              <Tab
                label="Tilaa taksi"
                component={Link}
                to="/taxi"
                disabled={value === 1}
                className={`${props.value === 1 ? classes.active : null} classes.navigationLink`}
              />
              <Tab
                label="Lue lisää palvelusta"
                component={MuiLink}
                href="http://opentaxi.fi/"
                target="_blank"
                rel="noopener noreferrer"
                disabled={value === 0}
                className={`${props.value === 0 ? classes.active : null} classes.navigationLink`}
              />
            </Tabs>
          ) : (
            <>
              <IconButton
                aria-label="More"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}
                className={classes.navigationLinkContainer}
                size="large"
              >
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                PaperProps={{
                  style: {
                    maxHeight: ITEM_HEIGHT * 4.5,
                    width: 200,
                  },
                }}
              >
                <MenuItem
                  selected={value === 0}
                  onClick={handleClose}
                  component={Link}
                  to={"/taxi"}
                >
                  <Typography color="primary">{"Tilaa taksi"}</Typography>
                </MenuItem>
                <MenuItem
                  selected={value === 1}
                  onClick={handleClose}
                  component={MuiLink}
                  href="http://opentaxi.fi/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography color="primary">
                    {"Lue lisää palvelusta"}
                  </Typography>
                </MenuItem>
              </Menu>
            </>
          )}
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;
